<div class="container mx-auto px-4">
    <div class="flex flex-wrap -mx-2">
        <div class="w-full sm:flex-none sm:w-1/6 px-2">
            <div class="text-secondary company-list-table mb-6">
                <div class="flex flex-wrap -mx-2">
                    <div class="w-full text-center sm:flex-none sm:w-full py-2 px-2"><b>List Size</b> <br/> &nbsp;</div>
                </div>
                <div class="shadow-bs list-height">
                    <div class="text-center py-2"><b>{{ listSize | number : 0 }}</b>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-full sm:flex-none sm:w-5/6 px-2">
            <div class="text-secondary company-list-table mb-6">
                <div class="flex flex-wrap -mx-2">
                    <div class="text-center w-1/5 py-2"><b>Matched</b></div>
                    <div class="text-center w-1/5 py-2"><b>Human + Email Verified Available Matches</b></div>
                    <div class="text-center w-1/5 py-2"><b>All Available Matches</b></div>
                    <div class="text-center w-1/5 py-2"><b>Outdated Matches</b><fa-icon class="info-icon si-icon ml-1" matTooltip="These matched contacts are outdated and need some work. Click the button below and we’ll get started." [icon]="['fal', 'circle-info']"></fa-icon></div>
                    <div class="text-center w-1/5 py-2"><b>Unmatched</b></div>
                </div>
                <div class="flex flex-wrap -mx-2 shadow-bs">
                    <div class="text-center w-1/5 py-2">
                        <b>{{matched | number : 0}}</b>
                        <span> ({{(matched / listSize) | percent }})</span>
                    </div>
                    <div class="text-center w-1/5 py-2">
                        <div>
                            <b class="a" (click)="onViewContact('humanVerified')">{{totalVerifiedContacts | number : 0}}</b>
                            ({{(totalVerifiedContacts / listSize) | percent}})
                        </div>
                    </div>
                    <div class="text-center w-1/5 py-2">
                        <div>
                            <b class="a" (click)="onViewContact('machineVerified')">{{ totalPendingVerificationContacts | number : 0 }}</b>
                            ({{(totalPendingVerificationContacts / listSize) | percent}})
                        </div>
                    </div>

                    <div class="text-center w-1/5 py-2">
                        <div>
                            <b>{{ suspendedCount }}</b>
                            <span>
                                ({{suspendedCount / listSize | percent}})
                            </span>
                        </div>
                        <div class="flex justify-center">
                          <div [matTooltip]="'Research on Demand'">
                            <button
                              matIconButton
                              class="mat-primary"
                              type="button"
                              [disabled]="!(suspendedCount > 0 && commonUtilService.hasRODCredit)"
                              (click)="onRoDModal('SUSPENDED')"
                            >
                              <fa-icon class="si-icon" [icon]="['fal', 'magnifying-glass-plus']"></fa-icon>
                            </button>
                          </div>
                         <div  [matTooltip]="'Export'">
                           <button
                             type="button"
                             matIconButton
                             class="mat-primary"
                             [matMenuTriggerFor]="suspendedMenu"
                             [disabled]="!(suspendedCount > 0)"
                           >
                             <fa-icon class="mb-1 si-icon" [icon]="['fal', 'share-from-square']"></fa-icon>
                           </button>
                           <mat-menu #suspendedMenu>
                             <button mat-menu-item (click)="onExportOriginalRecords('SUSPENDED')">
                               <span class="export-icon csv"></span>Export Original Records
                             </button>
                           </mat-menu>
                         </div>
                        </div>
                    </div>
                    <div class="text-center w-1/5 py-2">
                        <div>
                            <b>{{ matched | getUnmatchedCount : listSize }}</b>
                        </div>
                        <div class="flex justify-center">
                          <div  [matTooltip]="'Research on Demand'">
                            <button
                              matIconButton
                              class="mat-primary"
                              type="button"
                              [disabled]="!((((matched | getUnmatchedCount : listSize) > 0)) && commonUtilService.hasRODCredit)"
                              (click)="onRoDModal('UNMATCHED')"
                            >
                              <fa-icon class="si-icon" [icon]="['fal', 'magnifying-glass-plus']"></fa-icon>
                            </button>
                          </div>
                          <div  [matTooltip]="'Export'">
                            <button
                              type="button"
                              matIconButton
                              class="mat-primary"
                              [matMenuTriggerFor]="totalVerifiedMenu"
                              [disabled]="(!((matched | getUnmatchedCount : listSize) > 0))"
                            >
                              <fa-icon class="mb-1 si-icon" [icon]="['fal', 'share-from-square']"></fa-icon>
                            </button>
                            <mat-menu #totalVerifiedMenu>
                              <button mat-menu-item (click)="onExportOriginalRecords('UNMATCHED')">
                                <span class="export-icon csv"></span>Export Original Records
                              </button>
                            </mat-menu>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
